import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import InputRange from 'react-input-range';
import MonthsDropDown from './MonthsDropDown';

class LastPeriod extends React.PureComponent {

	// Setting component state here
	state = {
		monthOptions: [],
        ageValue: 'Select Age', //Default value 
		monthValue: {key : {value : 'Select Month'}}, // used for default selected value in dropdown
		showRangeSlider: false,
	};

	// sending default data to parent component on didMount
	componentDidMount() {
		document.addEventListener('click', this.handleClickOutside);
		// console.log('Rendered');
		this.setState((prevState, props) => {
			return {
				monthOptions: props.componentData.monthOptions,
				ageValue: this.props.currentMonthCycle.momAge
			};
		}, () => {
			this.props.sendLastPeriodData(this.state.monthValue, this.props.currentMonthCycle.momAge, false);
		})
	}

	handleClickOutside = (event) => {
		console.log(event.target.className)
		if (
			event.target.className === 'period-cycle-range' || 
			event.target.className === 'input-range__track input-range__track--active' || 
			event.target.className === 'range-wrap' ||
			event.target.className === 'input-range__track input-range__track--background' || event.target.className === 'input-range__slider' ||
			event.target.className === 'fa fa-birthday-cake') {
			this.setState({
				showRangeSlider: true
			})
		}
		else {
			this.setState({
				showRangeSlider: false
			})
		}
	}

	// sendign data to parent component as soon as is data is changed
	handleChange = (event) => {
		let {ageValue} = this.state;
		if(isNaN(ageValue)){
			ageValue = 'Select Age'
		}else{
			ageValue = Number(ageValue)
		}
		// if (event.target.name === 'm') {
			this.setState({ monthValue: event });
			// sending data from here to OvulationCalculator.js
			this.props.sendLastPeriodData(event, ageValue, true);
		// }
	};

	handleRangeChange = (event) => {
		// let rangeSlectorValue = event.target.value
		let rangeSlectorValue = event
		this.setState((prevState) => ({ ageValue: rangeSlectorValue}), () => {
			this.props.sendLastPeriodData(this.state.monthValue, this.state.ageValue, true);
		});
	}

	toggleRangeSlider = () => {
		this.setState((prevState) => ({
			showRangeSlider: !prevState.showRangeSlider
		}))
	}

	render() {
		// de-structuring the data from sate variable
		const { monthValue, monthOptions, ageValue } = this.state;
		let cycleLengthTextColor = false ? '#212529' : '#bfccdd';

		return (
			<>
				<div className="calculator-field">
					<label htmlFor="ovulation-calculator-date">
						<font style={{ verticalAlign: 'inherit' }}>
							<font style={{ verticalAlign: 'inherit' }}>{this.props.componentData.monthLabel.value}
							</font>
						</font>
					</label>
					<MonthsDropDown monthOptions={this.props.componentData.monthOptions} handleChange={this.handleChange} currentMonthCycle={this.props.currentMonthCycle}/>
				</div>
				<div className="duration-wrap">
					<label>{this.props.componentData.ageLabel.value}</label>
					<input type='text' readOnly className={this.state.showRangeSlider ? 'period-cycle-range' : ''} placeholder="Select Age"
                        value={isNaN(ageValue) ? ageValue : `${ageValue} years Old`} onClick={this.toggleRangeSlider}
						style={this.props.currentMonthCycle.momAge !== 0 ? { color: '#424C5F' } : { color: cycleLengthTextColor }} />
					<i className={this.state.showRangeSlider ? 'fa fa-birthday-cake' : 'fa fa-birthday-cake range'} onClick={this.toggleRangeSlider}></i>
					
					{this.state.showRangeSlider && <div className="range-wrap">
						<InputRange className="cycle-length"
							maxValue={Number(this.props.componentData.maxAge.value)}
							minValue={Number(this.props.componentData.minAge.value)}
							value={ageValue === 'Select Age' ? 25 : ageValue}
							onChange={this.handleRangeChange}
							onChangeComplete={value => console.log(value)} />
					</div>}
				</div>
			</>
		)
	}
}

LastPeriod.propTypes = {
	componentData: PropTypes.shape({}).isRequired,
	sendLastPeriodData: PropTypes.func.isRequired
}

export default withTranslation()(LastPeriod);